export function interceptors(instance) {
  // 添加请求拦截器
  instance.interceptors.request.use(
    function (config) {
      // 在发送请求之前做些什么
      let matchUrl = '/api/wechat/public/getJsTicket';
      let url = config.url;
      if (url.match(matchUrl)) {
        delete config.headers.Authorization;
      }
      config.metaData = { startTime: new Date() }; //做个记录，响应拦截器里诊断时，会求duration
      return config;
    },
    function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    }
  );
}

export function interceptorsResponse(instance) {
  // 添加response拦截器，作为诊断时，请求接口的记录
  instance.interceptors.response.use(
    function (response) {
      setTimeout(() => {
        if (sessionStorage.getItem('hly.superTraceId')) {
          let duration = 0;
          try {
            if (response.config.metaData.startTime) {
              duration = new Date() - response.config.metaData.startTime;
            }
          } catch (e) {}
          window._helios_track_event.recordHttpFetch({ data: response, duration: duration }).then();
        }
      });
      return response;
    },
    function (error) {
      setTimeout(() => {
        if (sessionStorage.getItem('hly.superTraceId')) {
          let duration = 0;
          try {
            if (error.response.config.metaData.startTime) {
              duration = new Date() - error.response.config.metaData.startTime;
            }
          } catch (e) {}
          window._helios_track_event.recordHttpFetch({ data: error.response, duration: duration }).then();
        }
      });
      return Promise.reject(error);
    }
  );
}
